<!-- 
	This is the dashboard layout, used in dashboard, tables, billing and profile pages.
-->

<template>
  <div>
    <!-- Dashboard Layout -->
    <a-layout class="layout-dashboard" id="layout-dashboard"
      :class="[navbarFixed ? 'navbar-fixed' : '', !sidebarCollapsed ? 'has-sidebar' : '', layoutClass]">
      <!-- Main Sidebar -->
      <!-- <DashboardSidebar :sidebarCollapsed="sidebarCollapsed" :sidebarColor="sidebarColor" :sidebarTheme="sidebarTheme" @toggleSidebar="toggleSidebar"></DashboardSidebar> -->
      <!-- / Main Sidebar -->

      <!-- Layout Content -->
      <div style="display: flex;flex-wrap:nowrap;">
        <div style="width:auto;">
          <Menu title="FlowStudio" :menulist="menulist" @menu-click="handleMenuClick" :menuIndex="nowIndex"></Menu>
        </div>
        <!-- Layout Header's Conditionally Fixed Wrapper -->
        <div style="flex:1;height:100vh;">
          <DashboardHeader :sidebarCollapsed="sidebarCollapsed" :navbarFixed="navbarFixed"
            @toggleSettingsDrawer="toggleSettingsDrawer" @toggleSidebar="toggleSidebar"></DashboardHeader>
          <div style="margin-top: 10px;height:calc(100vh - 80px);overflow-y:auto;max-width:calc(100vw - 250px)">
            <a-layout-content>

            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" :key="key" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" :key="key" />
          </a-layout-content>
          <DashboardFooter></DashboardFooter>
          <div class="sidebar-overlay" @click="sidebarCollapsed = true" v-show="!sidebarCollapsed"></div>
          <DashboardSettingsDrawer :showSettingsDrawer="showSettingsDrawer" :navbarFixed="navbarFixed"
            :sidebarTheme="sidebarTheme" @toggleSettingsDrawer="toggleSettingsDrawer"
            @toggleNavbarPosition="toggleNavbarPosition" @updateSidebarTheme="updateSidebarTheme"
            @updateSidebarColor="updateSidebarColor"></DashboardSettingsDrawer>
          </div>
        </div>
      </div>
      <!-- / Layout Content -->

      <!-- Settings Drawer -->

      <!-- / Settings Drawer -->
    </a-layout>
    <!-- / Dashboard Layout -->
  </div>
</template>

<script>
// import DashboardSidebar from "../components/Sidebars/DashboardSidebar"
import DashboardHeader from "../components/Headers/DashboardHeader"
import DashboardFooter from "../components/Footers/DashboardFooter"
import DashboardSettingsDrawer from "../components/Sidebars/DashboardSettingsDrawer"
import Menu from "../components/Menu.vue"
export default {
  components: {
    // DashboardSidebar,
    DashboardHeader,
    DashboardFooter,
    DashboardSettingsDrawer,
    Menu
  },
  data () {
    return {
      nowIndex: 0,
      menulist: [
        {
          img1: require('@/assets/images/menu1.png'),
          img2: require('@/assets/images/menu1-2.png'),
          text: 'ai对话'
        },
        {
          img1: require('@/assets/images/menu2.png'),
          img2: require('@/assets/images/menu2-2.png'),
          text: '协作空间'
        },
        // {
        //   img1: require('@/assets/images/menu3.png'),
        //   img2: require('@/assets/images/menu3-2.png'),
        //   text: '教学空间'
        // },
        // {
        //   img1: require('@/assets/images/menu4.png'),
        //   img2: require('@/assets/images/menu4-2.png'),
        //   text: '思维导图'
        // },
        {
          img1: require('@/assets/images/menu5.png'),
          img2: require('@/assets/images/menu5-2.png'),
          text: 'PPT生成'
        },
        // {
        //   img1: require('@/assets/images/menu6.png'),
        //   img2: require('@/assets/images/menu6-2.png'),
        //   text: '音频创作'
        // },
        {
          img1: require('@/assets/images/menu7.png'),
          img2: require('@/assets/images/menu7-2.png'),
          text: '我的知识库'
        },
        {
          img1: require('@/assets/images/menu8.png'),
          img2: require('@/assets/images/menu8-2.png'),
          text: '插件工具市场'
        },
        {
          img1: require('@/assets/images/menu7.png'),
          img2: require('@/assets/images/menu7-2.png'),
          text: 'word生成'
        },
        {
          img1: require('@/assets/images/menu4.png'),
          img2: require('@/assets/images/menu4-2.png'),
          text: '思维导图'
        },
      ],
      // Sidebar collapsed status.
      sidebarCollapsed: true,

      // Main sidebar color.
      sidebarColor: "primary",

      // Main sidebar theme : light, white, dark.
      sidebarTheme: "light",

      // Header fixed status.
      navbarFixed: false,

      // Settings drawer visiblility status.
      showSettingsDrawer: false
    }
  },
  watch: {
    $route (to, from) {
      this.sidebarCollapsed = true
    }
  },
  created(){
    console.log();
    let path=this.$route.fullPath
    // if(path=='/helper'){
    //   this.nowIndex=0
    // }else if(path=='/creatspace'||path=='/space'){
    //   this.nowIndex=1
    // }else if(path=='/mark_me'){
    //   this.nowIndex=3
    // }else if(path=='/ppt'){
    //   this.nowIndex=4
    // }else if(path=='/gptstore'){
    //   this.nowIndex=7
    // }else if(path=='/ai_write'){
    //   this.nowIndex=8
    // }
    if(path=='/helper'){
      this.nowIndex=0
    }else if(path=='/creatspace'||path=='/space'){
      this.nowIndex=1
    }else if(path=='/ppt'){
      this.nowIndex=2
    }else if(path=='/gptstore'){
      this.nowIndex=4
    }else if(path=='/ai_write'){
      this.nowIndex=5
    }else if(path=='/mark_me'){
      this.nowIndex=6
    }
    
  },
  methods: {
    handleMenuClick (data) {
      console.log('选中的菜单索引：',)
      let index = data.index
      // if (index == 0) {
      //   this.$router.push('/helper')
      // } else if (index == 1) {
      //   this.$router.push('/space')
      // } else if (index == 2) {
      //   location.href = '/addons/learning/login/manage_login'
      // } else if (index == 3) {
      //   this.$router.push('/mark_me')
      // } else if (index == 4) {
      //   this.$router.push('/ppt')
      // } else if (index == 5) {
      //   this.$message.warning('开发中...')
      //   return
      // } else if (index == 6) {
      //   this.$message.warning('开发中...')
      //   return
      // } else if (index == 7) {
      //   this.$router.push('/gptstore')
      // } else if (index == 8) {
      //   this.$router.push('/ai_write')
      // }
      
      
      if (index == 0) {
        this.$router.push('/helper')
      } else if (index == 1) {
        this.$router.push('/space')
      } else if (index == 2) {
        this.$router.push('/ppt')
      } else if (index == 3) {
        this.$message.warning('开发中...')
      } else if (index == 4) {
        this.$router.push('/gptstore')
      } else if (index == 5) {
        this.$router.push('/ai_write')
      } else if (index == 6) {
        this.$router.push('/mark_me')
      }
    },
    toggleSidebar (value) {
      this.sidebarCollapsed = value
    },
    toggleSettingsDrawer (value) {
      this.showSettingsDrawer = value
    },
    toggleNavbarPosition (value) {
      this.navbarFixed = value
    },
    updateSidebarTheme (value) {
      this.sidebarTheme = value
    },
    updateSidebarColor (value) {
      this.sidebarColor = value
    }
  },
  computed: {
    // Sets layout's element's class based on route's meta data.
    layoutClass () {
      return this.$route.meta.layoutClass
    },
    key () {
      return this.$route.path
    }
  }
}
</script>
